/**
 * Quem é o cliente do Portal na sessão.
 *
 * O token do cliente sai do Auth com a claim `role = portal_cliente`, posta
 * pelo hook do token (supabase/migrations/20261104154954_portal_cliente_acesso.sql).
 * Com esse papel o Postgres não deixa ler `user_roles`, então o front
 * reconhece o cliente pelo token, não pela consulta de papel da equipe.
 *
 * Só lê a claim, sem conferir assinatura: quem confere é o Postgres. Errar
 * aqui só muda qual tela abre, nunca o que o banco devolve.
 */
export const PAPEL_DO_CLIENTE_NO_TOKEN = 'portal_cliente';

export function papelDoToken(accessToken: string | null | undefined): string | null {
  if (!accessToken) return null;
  const partes = accessToken.split('.');
  if (partes.length !== 3) return null;
  try {
    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    const completo = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const carga = JSON.parse(atob(completo)) as { role?: unknown };
    return typeof carga.role === 'string' ? carga.role : null;
  } catch {
    return null;
  }
}

export function tokenDeCliente(accessToken: string | null | undefined): boolean {
  return papelDoToken(accessToken) === PAPEL_DO_CLIENTE_NO_TOKEN;
}
